import styled, { createGlobalStyle, css } from 'styled-components';
import LatoRangeOne from './assets/fonts/lato-range-one.woff2';
import LatoRangeTwo from './assets/fonts/lato-range-two.woff2';
import RobotoCyrillicExt from './assets/fonts/roboto-cyrillic-ext.woff2';
import RobotoCyrillic from './assets/fonts/roboto-cyrillic.woff2';
import RobotoGreekExt from './assets/fonts/roboto-greek-ext.woff2';
import RobotoGreek from './assets/fonts/roboto-greek.woff2';
import RobotoVietnamese from './assets/fonts/roboto-vietnamese.woff2';
import RobotoLatinExt from './assets/fonts/roboto-latin-ext.woff2';
import RobotoLatin from './assets/fonts/roboto-latin.woff2';

export const deviceWidth = {
  smartphone: 425,
  tablet: 1024,
  desktop: 1025,
};

const backgroundInput = '#f4f4f4';

export const colors = {
  primary: '#007e83',
  primaryHover: '#0099a1',
  warning: '#ffa800',
  error: '#f51423',
  black: '#000000',
  backgroundInput,
  backgroundBody: backgroundInput,
  backgroundButton: '#edf0f3',
  white: '#ffffff',
  whiteSmoke: '#e9e9e9',
  whisperGray: '#f4f4f4',
  lightGray: '#d3d3d3',
  transparent: 'transparent',
  quickSilver: '#a6a6a6',
  red: '#f50021',
  dimGray: '#636363',
  paternoster: '#c7c7c766',
  lightShadeGray: '#d2d2d2',
  pelicanBay: '#9aa9b0',
  nero: '#202020',
};

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url(${LatoRangeOne}) format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }

  @font-face {
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    src: url(${LatoRangeTwo}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoCyrillicExt}) format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }
  
  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoCyrillic}) format('woff2');
    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoGreekExt}) format('woff2');
    unicode-range: U+1F00-1FFF;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoGreek}) format('woff2');
    unicode-range: U+0370-03FF;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoVietnamese}) format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoLatinExt}) format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src: url(${RobotoLatin}) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }

  html {
    overflow: hidden;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  body {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 100%;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }

  *, *:before, *:after {
    box-sizing: border-box;
  }

  * img {
    vertical-align: middle;
  }

  .selected-fill{
    fill: #ffef99 !important;
  }

  .delete-selection-modal-header{
    color: rgba(0, 0, 0, 0.87);
    font-size: 1.5rem;
    font-weight: 400;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    padding-left: 10px;
  }

  .delete-selection-modal-button-text{
    font-size: 1.2rem;
    font-weight: 400;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  }

  #root{
    height: 100%;
    width: 100%;
    position: fixed;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  #renderer-svg{
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .colon {
    &:after {
      content: ': ';
    }
  }
`;

// the styles were moved from SideBar/style.css file
const SideBarStyles = css`
  @keyframes barAnimationOpen {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes barAnimationClose {
    0% {
      opacity: 1;
      transform: translateY(0);
    }

    100% {
      opacity: 0;
      transform: translateY(30px);
    }
  }

  .insertBarOpen {
    animation-name: barAnimationOpen;
    animation-duration: 0.5s;
  }

  .insertBarClosed {
    animation-name: barAnimationClose;
    animation-duration: 0.5s;
  }

  .Select {
    height: 49px;
    padding: 12px 20px;
    border-radius: 4px;
    background-color: ${colors.whisperGray};
    border: none;
    font-size: 16px !important;
    box-shadow: none !important;
    padding: 0 !important;
    padding: 0 !important;

    * {
      font-size: 16px !important;
      border: none;
      box-shadow: none !important;
      height: 100%;
    }
  }

  .MenuItem {
    font-size: 16px !important;
  }

  .inputContainer {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 49px;
    max-height: 49px;
    font-weight: 400;
    border-radius: 4px;
    background-color: ${colors.whisperGray};
    overflow: hidden;
    :hover * {
      stroke: #007e83;
    }
    :active * {
      stroke: #202020;
    }

    &.disabled {
      :hover * {
        stroke: ${colors.lightGray};
      }
    }
  }

  .inputContainerWhite {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    height: 49px;
    max-height: 49px;
    font-weight: 400;
    border-radius: 4px;
    background-color: #ffffff;
    overflow: hidden;
    :hover * {
      stroke: #007e83;
    }
    :active * {
      stroke: #202020;
    }
  }

  .checkBoxContainer {
    display: flex;
    align-items: center;
    justify-content: left;
    height: auto;
    max-height: 49px;
    font-weight: 400;
    border-radius: 4px;
    background-color: none;
    overflow: hidden;
  }

  .checkboxLabel {
    margin-left: 10px;
  }

  input {
    text-align: center;
    :hover {
      border: solid 1px #e9e9e9;
    }
    :focus {
      border: solid 1px #007e83;
    }
  }

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    overflow: hidden;
    :hover {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      svg {
        fill: #007e83;
      }
    }
    :active {
      box-shadow: none;
      svg {
        fill: #007e83;
      }
    }

    &.disabled {
      box-shadow: none;
      svg {
        fill: #d2d2d2;
        stroke: #d2d2d2;
      }
    }
  }

  * .ColorItem {
    border-radius: 4px;
    width: 20px;
    height: 20px;

    &:hover {
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
      border: solid 1px #ffffff;
    }
  }

  * .AddColorButton {
    border-radius: 4px;
    width: 20px;
    height: 20px;

    &:hover {
      box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.5);
      border: solid 1px #ffffff;
    }
  }
`;

// the styles were moved from Expandable/style.css file
const ExpandableStyles = css`
  .Accordion {
    width: 100% !important;
    border-radius: 0 !important;
    margin: 0 !important;
    box-shadow: unset !important;
    font-size: 18px;
    font-family: 'IBMPlexSans';
    font-weight: 400;
  }

  .AccordionGrey {
    width: calc(100% - 40px) !important;
    border-radius: 0 !important;
    margin: 0 !important;
    box-shadow: unset !important;
    font-size: 18px !important;
    background-color: ${colors.whisperGray} !important;
    border-radius: 4px !important;
    margin: 5px 20px !important;
  }

  .AccordionTitle {
    font-weight: 600 !important;
    font-size: 18px !important;
  }

  .AccordionDetails {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: 0px 16px 0px !important;
  }

  .AccordionDetailsGrey {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    padding: 0px 20px 0px !important;
  }
`;

export const WebComponentGlobalStyles = createGlobalStyle`
  *, *:before, *:after {
    box-sizing: border-box;
  }

  * img {
    vertical-align: middle;
  }

  .selected-fill {
    fill: #ffef99 !important;
  }

  .delete-selection-modal-header {
    color: rgba(0, 0, 0, 0.87);
    font-size: 1.5rem;
    font-weight: 400;
    padding-left: 10px;
  }

  .delete-selection-modal-button-text {
    font-size: 1.2rem;
    font-weight: 400;
  }

  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  #renderer-svg {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .decoration {
    pointerEvents: none;
  }

  .colon {
    &:after {
      content: ': ';
    }
  }

  p {
    margin: 0;
  }

  ${SideBarStyles}
  ${ExpandableStyles}
`;

export const CTAButton = styled.div`
  height: 50px;

  background-color: ${props =>
    props.primary ? colors.primary : colors.backgroundButton};
  color: ${props => (props.primary ? '#ffffff' : colors.primary)};

  display: flex;
  justify-content: center;
  align-items: center;

  font-family: Lato;
  font-size: 1.125em;
  text-align: center;
  text-transform: uppercase;

  border-radius: 2px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  opacity: ${props => (props.disabled ? '0.4' : '1')};

  pointer-events: ${props => (props.disabled ? 'none' : 'all')};
  cursor: pointer;
`;

export const MuiButton = {
  MuiButton: {
    styleOverrides: {
      root: {
        color: colors.black,
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
};
